import camelcaseKeys from 'camelcase-keys';
import { normalize } from 'normalizr';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import * as actions from '../../../actions/static-catalogs/brands';
import * as authSelectors from '../../../reducers/auth';
import * as schemas from '../../../schemas/brands';
import * as types from '../../../types/static-catalogs/brands';
import API_BASE_URL from '../../settings/apibaseurl';

/* -------------------------------------------------------------------------- */
/*                                 FETCH LIST                                 */
/* -------------------------------------------------------------------------- */
function* fetchBrandsList(action) {
  const { brandId } = action.payload;
  try {
    const isAuth = yield select(authSelectors.isAuthenticated);
    if (isAuth) {
      const token = yield select(authSelectors.getAuthToken);
      const response = yield call(fetch, `${API_BASE_URL}/brand`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      const jsonResult = yield response.json();
      if (response.status <= 300 && jsonResult.success) {
        const resultData = jsonResult.data.map((result) => camelcaseKeys(result));
        const {
          entities: { brands },
          result //order
        } = normalize(resultData, schemas.brands); //normalize data to byId and order
        yield put(actions.completeFetchingBrands(brands, result));
      } else {
        const error = {
          errorMessage: jsonResult.message,
          errorNumber: jsonResult.number
        };
        // alerts.showErrorAlertFailChanges({ error });
        yield put(actions.failFetchingBrands(error));
      }
    }
  } catch (err) {
    const error = {
      errorMessage: err.toString(),
      errorNumber: -1
    };
    // alerts.showErrorAlertFailChanges({ error });
    yield put(actions.failFetchingBrands(error));
  }
}

export function* watchFetchBrandsList() {
  yield takeEvery(types.BRANDS_FETCH_STARTED, fetchBrandsList);
}
